import {
  apiPrefix,
  ConnectionService,
  httpMethodType,
} from "./Connecion.service";

const RESOURCE = "auth/Device";

class AuthDeviceService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async getDeviceModel(orgId, deviceUid) {
    const url = `${this.basedUrl}/deviceModel`;
    const params = { organizationId: orgId, uid: deviceUid };
    return super.sendRequest(url, { params }, true);
  }

  async registerDevice(payload) {
    const url = `${this.basedUrl}/register`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(payload),
    };

    return super.sendRequest(url, config, true);
  }

  async addDevice(data) {
    const url = `${this.basedUrl}/bulkCreateToInventory `;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }

  async unregisterDevice(data) {
    const url = `${this.basedUrl}/bulkUnregister `;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }

  async removeDevice(data) {
    const url = `${this.basedUrl}/bulkFullDelete `;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };

    return super.sendRequest(url, config, true);
  }
}

export default new AuthDeviceService();
